var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStarSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.25C3.80964 3.25 3.25 3.80964 3.25 4.5V19.5C3.25 20.1904 3.80964 20.75 4.5 20.75H19.5C20.1904 20.75 20.75 20.1904 20.75 19.5V4.5C20.75 3.80964 20.1904 3.25 19.5 3.25H4.5ZM1.75 4.5C1.75 2.98122 2.98122 1.75 4.5 1.75H19.5C21.0188 1.75 22.25 2.98122 22.25 4.5V19.5C22.25 21.0188 21.0188 22.25 19.5 22.25H4.5C2.98122 22.25 1.75 21.0188 1.75 19.5V4.5Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0015 7.91876L13.1398 10.0396C13.3415 10.4157 13.7103 10.6612 14.1174 10.7228L16.5121 11.085L14.8237 12.6925C14.5177 12.9839 14.3665 13.4088 14.4375 13.8366L14.8173 16.1266L12.5934 15.0507C12.2205 14.8704 11.7827 14.8704 11.4097 15.0507L9.18573 16.1266L9.56555 13.8367C9.63649 13.409 9.48552 12.9841 9.17937 12.6926L7.49096 11.085L9.88568 10.7228M13.1831 6.94831C12.6834 6.01723 11.3197 6.01723 10.82 6.94831L9.58393 9.25139L6.88253 9.65992C5.8502 9.81602 5.32707 11.0957 6.15555 11.8846L8.06696 13.7046L7.64729 16.2348C7.45986 17.3647 8.66014 18.0471 9.55635 17.6136L12.0015 16.4307L14.4466 17.6135C15.3427 18.047 16.5432 17.3648 16.3557 16.2347L15.9361 13.7046L17.8475 11.8847C18.676 11.0957 18.1529 9.81601 17.1206 9.65993L14.4191 9.25138L13.1831 6.94831Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarSquare);
export default __webpack_public_path__ + "static/media/ic-star-square.9eed9227dbb57376d8a3ea53e4758f7f.svg";
export { ForwardRef as ReactComponent };